// src/pages/TermsOfUse.jsx
import React from "react";

export default function TermsOfUse() {
  const updatedAt = "16 janvier 2026";
  const companyName = "GoShop";
  const contactEmail = "goshop@gmail.com"; // ✅ mets ton vrai email

  return (
    <div style={{ background: "#0b1226", minHeight: "100vh", padding: "24px 12px" }}>
      <div
        style={{
          maxWidth: 980,
          margin: "0 auto",
          background: "#ffffff",
          borderRadius: 18,
          padding: "22px 18px",
          boxShadow: "0 18px 45px rgba(0,0,0,.18)",
        }}
      >
        <header style={{ marginBottom: 14 }}>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 900, color: "#0f172a" }}>
            Conditions Générales d’Utilisation (CGU)
          </h1>
          <p style={{ margin: "6px 0 0", color: "#64748b", fontSize: 13 }}>
            Dernière mise à jour : <strong>{updatedAt}</strong>
          </p>
        </header>

        <section style={{ color: "#111827", lineHeight: 1.65, fontSize: 14 }}>
          <p>
            Les présentes CGU régissent l’utilisation de la plateforme <strong>{companyName}</strong> (site et services).
            En utilisant la plateforme, vous acceptez ces conditions.
          </p>

          <h2 style={h2}>1) Définitions</h2>
          <ul style={ul}>
            <li><strong>Plateforme</strong> : le site/app {companyName}.</li>
            <li><strong>Client</strong> : toute personne qui consulte ou commande.</li>
            <li><strong>Vendeur</strong> : tout utilisateur qui publie des produits.</li>
            <li><strong>Commande</strong> : demande d’achat effectuée via la plateforme (panier/WhatsApp/paiement).</li>
          </ul>

          <h2 style={h2}>2) Accès au service</h2>
          <p>
            L’accès peut être interrompu temporairement (maintenance, incident). Nous faisons le maximum pour assurer la disponibilité,
            sans garantie d’absence d’interruption.
          </p>

          <h2 style={h2}>3) Produits, prix et disponibilité</h2>
          <ul style={ul}>
            <li>Les fiches produits sont publiées par les vendeurs, sous contrôle de validation {companyName}.</li>
            <li>Les prix et stocks peuvent évoluer. En cas d’erreur manifeste, {companyName} peut corriger ou annuler une commande.</li>
            <li>Les images sont illustratives : de légères différences peuvent exister.</li>
          </ul>

          <h2 style={h2}>4) Commandes</h2>
          <ul style={ul}>
            <li>Une commande peut être confirmée via WhatsApp, appel ou email.</li>
            <li>Le vendeur et/ou {companyName} peut refuser une commande en cas d’indisponibilité, suspicion de fraude ou non-respect des règles.</li>
            <li>Vous devez fournir des informations exactes (contact, adresse, etc.).</li>
          </ul>

          <h2 style={h2}>5) Paiements</h2>
          <p>
            Les paiements peuvent être traités via des prestataires tiers (Mobile Money, passerelles de paiement, etc.).
            Vous acceptez les conditions de ces prestataires.
          </p>

          <h2 style={h2}>6) Livraison et retrait</h2>
          <ul style={ul}>
            <li>Les délais de livraison sont indicatifs.</li>
            <li>Les frais et modalités dépendent du vendeur ou du transporteur.</li>
            <li>En cas de problème (retard, article manquant), contactez le support ou le vendeur.</li>
          </ul>

          <h2 style={h2}>7) Retours, remboursements et litiges</h2>
          <p>
            Les conditions de retour/remboursement dépendent du type de produit et des règles du vendeur (et parfois de la loi locale).
            {companyName} peut assister à la médiation mais n’est pas responsable du contenu/qualité des produits vendus par un vendeur,
            sauf indication contraire.
          </p>

          <h2 style={h2}>8) Comptes vendeurs et validation</h2>
          <ul style={ul}>
            <li>Les produits vendeurs peuvent être soumis à validation avant publication.</li>
            <li>En cas de modification d’un produit, il peut repasser en <strong>pending</strong> pour revue.</li>
            <li>Le vendeur s’engage à publier des informations vraies et à respecter la Charte de communauté.</li>
          </ul>

          <h2 style={h2}>9) Contenus interdits</h2>
          <ul style={ul}>
            <li>Produits illégaux, contrefaçons, contenus haineux, violence, arnaque, fausses promotions.</li>
            <li>Informations trompeuses (prix, photos, marque, origine).</li>
            <li>Spam, harcèlement, comportements abusifs.</li>
          </ul>

          <h2 style={h2}>10) Responsabilités</h2>
          <p>
            {companyName} agit comme plateforme de mise en relation. Chaque vendeur est responsable de ses produits,
            de leur conformité et de leur livraison (si la livraison est à sa charge). {companyName} peut retirer
            un contenu, suspendre un compte, ou limiter l’accès pour sécurité/conformité.
          </p>

          <h2 style={h2}>11) Protection des données</h2>
          <p>
            Consultez la page <a href="/privacy" style={link}>Politique de confidentialité</a>.
          </p>

          <h2 style={h2}>12) Modifications des CGU</h2>
          <p>
            Nous pouvons mettre à jour ces CGU. La version applicable est celle affichée sur la plateforme à la date d’utilisation.
          </p>

          <h2 style={h2}>13) Contact</h2>
          <p>
            Pour toute question :{" "}
            <a href={`mailto:${contactEmail}`} style={link}>
              {contactEmail}
            </a>
          </p>

          <hr style={{ border: "none", borderTop: "1px solid #e5e7eb", margin: "18px 0" }} />
          <p style={{ color: "#64748b", fontSize: 13, margin: 0 }}>
            © {new Date().getFullYear()} {companyName}. Tous droits réservés.
          </p>
        </section>
      </div>
    </div>
  );
}

const h2 = {
  marginTop: 16,
  marginBottom: 8,
  fontSize: 16,
  fontWeight: 900,
  color: "#0f172a",
};

const ul = {
  marginTop: 6,
  marginBottom: 10,
  paddingLeft: 18,
};

const link = { color: "#1e40af", fontWeight: 800, textDecoration: "none" };
